import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { glassEffect } from '../../theme';

export const NavContainer = styled.nav`
  ${glassEffect}
  background: ${({ theme }) => theme.navBg};
  display: flex;
  flex-direction: column;
  width: 250px;
  height: 100%; /* Use 100% to fill parent */
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px;
  transition: transform 0.3s ease-in-out;
  z-index: 2000; /* FIX: Set a very high z-index */

  @media (max-width: 768px) {
    transform: ${props => (props.$isOpen ? 'translateX(0)' : 'translateX(-100%)')};
  }
`;

export const NavHeader = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.heading};
  margin: 0 0 40px 0;
  padding-left: 15px;

  /* FIX: Add top padding to make space for the close ('X') button on mobile */
  @media (max-width: 768px) {
    padding-top: 40px;
  }
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1; /* This makes the list take up the available space */
  overflow-y: auto; /* This makes ONLY the list scrollable */
`;

export const NavItem = styled.li`
  margin-bottom: 10px;
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-radius: 8px;
  color: ${({ theme }) => theme.navText};
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s, color 0.2s;

  &.active, &:hover {
    background-color: ${({ theme }) => theme.navActiveBg};
    color: ${({ theme }) => theme.navTextActive};
  }

  svg {
    margin-right: 15px;
  }
`;

export const BottomControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoutButton = styled.button`
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-radius: 8px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  color: ${({ theme }) => theme.navText}; // Using theme variable
  transition: background-color 0.2s, color 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.navActiveBg}; // Using theme variable
    color: ${({ theme }) => theme.navTextActive}; // Using theme variable
  }
  
  svg {
    margin-right: 15px;
  }
`;